import { Component, OnInit } from '@angular/core';
import { catchError } from 'rxjs';
import { TrackService } from 'src/app/services/track.service';
import { FormService } from 'src/app/shared/form.service';
import { ProposalService } from 'src/app/shared/proposal.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-data-summary',
  templateUrl: './data-summary.component.html',
  styleUrls: ['./data-summary.component.scss']
})
export class DataSummaryComponent implements OnInit {
  formValues;
  calculatedPremiums$;
  preloading = { title: 'proposal.title', image: 'woman-loading-page' };
  chosenPackageLabel: string;
  deductible: number;

  private usages : any[] = [];
  private packages: any[] = [];
  private propertySubcategory :any [] = [];
  constructor(
    private formService: FormService,
    public trackService: TrackService,
    public sharedService: SharedService,
    private proposalService: ProposalService) { }

  ngOnInit(): void {
    this.calculatedPremiums$ = this.proposalService.calculatedPremiums$;
    this.formValues = this.formService.getMainForm().getRawValue();
    this.sharedService.$usage.subscribe(usages => this.usages = usages);
    this.sharedService.productTypes$.subscribe((packages) => {
        this.packages = packages;
        this.chosenPackageLabel = this.packages.find(insurancePackage => insurancePackage.value == this.formValues.chosenPackageId)?.label;
    });
    this.sharedService.$propertyCategories.subscribe(subcategory => this.propertySubcategory = subcategory.propertySubcategories);
    this.proposalService.insertTrackingData().pipe(catchError(error => { throw error})).subscribe();
    this.sharedService.currency$.subscribe(currency => this.deductible = currency.main == "EUR" ? 35.79 : 70);
  }

  getUsage() {
    return this.usages.find(usage => usage.value === this.formValues.purpose)?.label;
  }

  getSelectedPackage() {
    return this.packages.find(insurancePackage => insurancePackage.value === this.formValues.chosenPackageId)?.label;
  }

  isOwnerCompany() {
    return !!this.formValues.ownerData?.companyName;
  }

  subcategoryLabel(){
    if(this.formValues.propertySubcategoryLabel===null){
      return this.propertySubcategory.find(subcat => subcat.value === this.formValues.propertySubcategory)?.label;
    }
    else return this.formValues.propertySubcategoryLabel
   
  }

  getPremium(premiums, selectedPayments, selectedPackageId) {
    const packages = {
      '1': 'Comfort',
      '2': 'Extra',
      '3': 'Max'
    };

    const payments = {
      '1': 'One',
      '2': 'Two',
      '4': 'Four'
    }

    return premiums[`bottom${packages[selectedPackageId]}${payments[selectedPayments]}`];
  }
}
